const init = () => {
    const calculatorsElements = document.querySelectorAll('.ns-merchant-enterprise-calc');
    calculatorsElements.forEach((targetCalculator)=>{
        const tabList = targetCalculator.querySelector('[role="tablist"]');
        const tabs = tabList.querySelectorAll('[role="tab"]');
        const tabPanels = targetCalculator.querySelectorAll('[role="tabpanel"]');

        const activateTab = (tab) => {
            tabs.forEach(tab => {
                tab.setAttribute('aria-selected', 'false');
                tab.setAttribute('tabindex', '-1');
            });

            tabPanels.forEach(panel => {
                panel.hidden = true;
            });

            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('tabindex', '0');
            tab.focus();
            const panelId = tab.getAttribute('aria-controls');
            document.getElementById(panelId).removeAttribute("hidden");
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', () => activateTab(tab));
            tab.addEventListener('keydown', e => {
                const index = Array.prototype.indexOf.call(tabs, tab);
                let newIndex = null;
                switch (e.key) {
                    case 'ArrowRight':
                        newIndex = (index + 1) % tabs.length;
                        break;
                    case 'ArrowLeft':
                        newIndex = (index - 1 + tabs.length) % tabs.length;
                        break;
                    case 'Home':
                        newIndex = 0;
                        break;
                    case 'End':
                        newIndex = tabs.length - 1;
                        break;
                }
                if (newIndex !== null) {
                    e.preventDefault();
                    activateTab(tabs[newIndex]);
                }
            });
        });
    });
    const calculatorPanels = document.querySelectorAll('.ns-merchant-enterprise-calc__calculator-card');
    calculatorPanels.forEach((targetCalculatorPanel)=>{
        CalculatorInit(targetCalculatorPanel);
    });
};

window.addEventListener("DOMContentLoaded", init, false);


function CalculatorInit(calculatorContainer){
    const idPrefix = calculatorContainer.dataset.idPrefix;

    const amountRange = calculatorContainer.querySelector(`#${idPrefix}amountRange`);
    const amountValue = calculatorContainer.querySelector(`#${idPrefix}amountValue`);
    const trackAmount = calculatorContainer.querySelector(`#${idPrefix}track-amount`);

    const countRange = calculatorContainer.querySelector(`#${idPrefix}countRange`);
    const countRangeDecorator = document.querySelector(`#${idPrefix}countRangeDecorator`);
    const countValue = calculatorContainer.querySelector(`#${idPrefix}countValue`);
    const trackCount = calculatorContainer.querySelector(`#${idPrefix}track-count`);

    amountRange.addEventListener("input", () =>
        updateValue(amountRange, amountValue, "", trackAmount)
    );
    countRange.addEventListener("input", () =>
        updateValue(countRange, countValue, "", trackCount, countRangeDecorator)
    );

    updateValue(amountRange, amountValue, "", trackAmount);
    updateValue(countRange, countValue, "", trackCount, countRangeDecorator);

    amountValue.addEventListener("blur", () => {
        const val = parseInt(amountValue.textContent.replace(/[^\d]/g, ""));
        if (!isNaN(val)) {
            amountRange.value = val;
            updateValue(amountRange, amountValue, "", trackAmount);
        }
    });

    countValue.addEventListener("blur", () => {
        const val = parseInt(countValue.textContent.replace(/[^\d]/g, ""));
        if (!isNaN(val)) {
            countRange.value = val;
            updateValue(countRange, countValue, "", trackCount, countRangeDecorator);
        }
    });

    countValue.addEventListener("keydown", (e) => {
        const allowedKeys = ["ArrowLeft", "ArrowRight", "Tab", "Home", "End"];
        const modifyingKeys = ["Backspace", "Delete"];

        const sel = window.getSelection();
        const range = sel.getRangeAt(0);
        const cursorPos = range.startOffset;
        const currentText = e.target.innerText;

        let newText = currentText;

        if (allowedKeys.includes(e.key)) return;

        if (modifyingKeys.includes(e.key)) {
            if (e.key === "Backspace" && cursorPos > 0) {
                newText = currentText.slice(0, cursorPos - 1) + currentText.slice(cursorPos);
            } else if (e.key === "Delete") {
                newText = currentText.slice(0, cursorPos) + currentText.slice(cursorPos + 1);
            }
        } else if (/^[0-9]$/.test(e.key)) {
            newText = currentText.slice(0, cursorPos) + e.key + currentText.slice(cursorPos);
        } else {
            e.preventDefault();
            return;
        }

        const value = parseFloat(newText);

        if (!isNaN(value)) {
            if (value < 10) {
                e.preventDefault();
                setValueAndMoveCursor(e.target, "10");
            } else if (value > 1000) {
                e.preventDefault();
                setValueAndMoveCursor(e.target, "1000");
            }
        }
    });

    amountValue.addEventListener("keydown", (e) => {
        const allowedKeys = ["ArrowLeft", "ArrowRight", "Tab", "Home", "End"];
        const modifyingKeys = ["Backspace", "Delete"];

        const sel = window.getSelection();
        const range = sel.getRangeAt(0);
        const cursorPos = range.startOffset;
        const currentText = e.target.innerText;

        let newText = currentText;

        if (allowedKeys.includes(e.key)) return;

        if (modifyingKeys.includes(e.key)) {
            if (e.key === "Backspace" && cursorPos > 0) {
                newText = currentText.slice(0, cursorPos - 1) + currentText.slice(cursorPos);
            } else if (e.key === "Delete") {
                newText = currentText.slice(0, cursorPos) + currentText.slice(cursorPos + 1);
            }
        } else if (/^[0-9]$/.test(e.key)) {
            newText = currentText.slice(0, cursorPos) + e.key + currentText.slice(cursorPos);
        } else {
            e.preventDefault();
            return;
        }

        const value = parseFloat(newText);

        if (!isNaN(value)) {
            if (value < 15) {
                e.preventDefault();
                setValueAndMoveCursor(e.target, "15");
            } else if (value > 150) {
                e.preventDefault();
                setValueAndMoveCursor(e.target, "150");
            }
        }
    });

    // Функция подстановки значения и возврата курсора
    function setValueAndMoveCursor(target, value) {
        target.innerText = value;
        setTimeout(() => {
            const sel = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(target);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        }, 0);
    }

    // countValue.addEventListener("keyup", (e) => {
    //     countRange.value = e.target.innerText;
    //     setTimeout(() => {
    //         updateValue(countRange, countValue, "", trackCount, countRangeDecorator);
    //     }, 500);
    // });
    // amountValue.addEventListener("keyup", (e) => {
    //     amountRange.value = e.target.innerText;
    //     setTimeout(() => {
    //         updateValue(amountRange, amountValue, "", trackAmount);
    //     }, 500);
    // });

    function updateValue(range, output, prefix = "", track, countRangeDecorator = null) {
        const val = range.value;
        output.textContent = prefix + val;
        const calculatedWidth = (val - range.min) / (range.max - range.min) * 100;
        track.style.width = `${calculatedWidth}%`;

        if(countRangeDecorator) {
            countRangeDecorator.style.left = `calc(${calculatedWidth}% - ${(calculatedWidth / 100) * 16}px)`;
        }

        switch (idPrefix) {
            case "uk-":
                document.getElementById(`${idPrefix}result`).innerHTML = (countRange.value * (amountRange.value * 0.01 + 0.2)).toFixed(0);
                break;
            case "eea-":
                document.getElementById(`${idPrefix}result`).innerHTML = (countRange.value * (amountRange.value * 0.015 + 0.2)).toFixed(0);
                break;
            default:
                console.log("idPrefix - "+idPrefix);
        }

    }
}


